import actionCreatorFactory from "typescript-fsa";
import { FilterList } from "./types";

const actionCreator = actionCreatorFactory("@@Filter");

export const filterActions = {
  fetchFilters: actionCreator.async<{}, { filters: FilterList[] }>("FETCH_FILTERS"),
  resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
};
